<div class="k-overlay" *ngIf="isOpened"></div>
<kendo-dialog *ngIf="isOpened" [title]="title" (close)="close()">
    <form [formGroup]="form" class="k-form" (ngSubmit)="save()">
        <fieldset>
            <kendo-gridlayout [cols]="[400]" [gap]="5">
                <kendo-gridlayout-item [row]="1" *ngIf="task.description && task.description !== ''">
                    <h4 class="margin-bottom-0 margin-top-10">{{ task.title }}</h4>
                    <p class="task-description">
                        {{ task.description }}
                    </p>
                </kendo-gridlayout-item>
                <kendo-gridlayout-item [row]="2" *ngIf="task.needsMention">
                    <kendo-formfield>
                        <kendo-label>{{ 'cf-company-tasks.dialog.registerEventDialog.label.mention' | translate }}:</kendo-label>
                        <input name="mention" formControlName="mention" kendoTextBox required />
                        <kendo-formerror>{{ 'input.required.error' | translate }}</kendo-formerror>
                    </kendo-formfield>
                </kendo-gridlayout-item>
                <kendo-gridlayout-item [row]="3" *ngIf="task.needsAttachment">
                    <kendo-formfield>
                        <kendo-label text="{{ 'cf-company-tasks.dialog.registerEventDialog.label.file' | translate }}"> </kendo-label>
                        <kendo-fileselect [multiple]="false" [restrictions]="fileRestrictions" formControlName="files" required>
                        </kendo-fileselect>
                        <kendo-formerror>{{ 'file-select.required.error' | translate }}</kendo-formerror>
                    </kendo-formfield>
                </kendo-gridlayout-item>
            </kendo-gridlayout>
        </fieldset>

        <div class="k-actions k-actions-end">
            <button kendoButton type="submit" themeColor="success">
                <i class="fas fa-save"></i>
                {{ 'labels.save' | translate }}
            </button>
            <button kendoButton type="button" icon="close" themeColor="dark" (click)="close()">
                {{ 'labels.cancel' | translate }}
            </button>
        </div>
    </form>
</kendo-dialog>
